import { render, staticRenderFns } from "./WaiverAdmin.vue?vue&type=template&id=274bb89e&"
import script from "./WaiverAdmin.vue?vue&type=script&lang=js&"
export * from "./WaiverAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports